import React from 'react';
import LogoImage from 'assets/images/logo-sitg.png';
import TextImage from 'assets/images/text-date-location.png';
import { StyledLogoImage, StyledTextImage, StyledLogoImageWithText } from './styles';
import { graphql, StaticQuery } from 'gatsby';

export const Image: React.FunctionComponent<any> = () => <StyledLogoImage image={LogoImage}>Splendour In The Grass</StyledLogoImage>;

export const Text: React.FunctionComponent<any> = () => (
  <StyledTextImage image={TextImage}>19, 20, 21 July 2019, North Byron Parklands</StyledTextImage>
);

export const ImageWithText: React.FunctionComponent<any> = () => (
  <StaticQuery
  query={graphql`
  query Logo {
    wordpress {
      themeSettings {
      themeOptions {
        logo {
          altText
          sourceUrl
        }
      }
    }
    }
  }
  `}
  render={({wordpress}) => {
    if(wordpress?.themeSettings?.themeOptions?.logo?.sourceUrl){
      return <StyledLogoImageWithText image={wordpress.themeSettings.themeOptions.logo.sourceUrl}>{wordpress.themeSettings.themeOptions.logo.altText}</StyledLogoImageWithText>
    }
    return <><Image /><Text /></>
  }}
   />
)